import { TeamMemberChecklist } from '@/components/team/TeamMemberChecklist';
import { Box, Flex, Spinner, Text } from '@chakra-ui/react';
import type { TeamMember } from '@fluenceur/types';
import { useTranslation } from 'react-i18next';

const I18N_PREFIX = 'integrations.googleDrive.sharing.invite';

interface DriveTeammatesChecklistProps {
  teamMembers: TeamMember[];
  selectedIds: Set<string>;
  alreadySharedEmails: Set<string>;
  onToggle: (memberId: string) => void;
  isLoading: boolean;
}

const DriveTeammatesChecklist = ({
  teamMembers,
  selectedIds,
  alreadySharedEmails,
  onToggle,
  isLoading,
}: DriveTeammatesChecklistProps) => {
  const { t } = useTranslation();

  return (
    <Box>
      <Text fontSize="sm" fontWeight="medium" mb={3}>
        {t(`${I18N_PREFIX}.teammatesLabel`, { count: teamMembers.length })}
      </Text>
      {isLoading ? (
        <Flex py={4} justify="center">
          <Spinner size="sm" />
        </Flex>
      ) : teamMembers.length === 0 ? (
        <Text fontSize="sm" color="gray.fg">
          {t(`${I18N_PREFIX}.teamEmpty`)}
        </Text>
      ) : (
        <TeamMemberChecklist
          members={teamMembers}
          selectedIds={selectedIds}
          onToggle={onToggle}
          isLocked={(member) => alreadySharedEmails.has(member.email.toLowerCase())}
          lockedLabel={t(`${I18N_PREFIX}.alreadyHasAccess`)}
        />
      )}
    </Box>
  );
};

export default DriveTeammatesChecklist;
